import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as z from "zod";

export const getAddressesFromName = {
  name: "getAddressesFromName" as const,
  input: z.object({ nameSearchString: z.string() }),
  output: z.object({
    suggestions: z.array(
      FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    ),
  }),
};
